import styled from 'styled-components';

export const ContentCenterDiv = styled.div`
	display: flex;
	justify-content: center;
`;

export const FiltersContainer = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin: 10px;
`;

export const FiltersListDiv = styled.div`
	display: flex;
	justify-content: space-evenly;
	align-items: center;
	margin: 10px;
`;

export const SettingsContainer = styled.div`
	margin: 15px;
	margin-top: 0px;
`;

export const SettingsHighDiv = styled.div`
	margin-left: 10px;
`;
